export { WebCamCard } from "./web-cam-card";
